<template>
    <!-- 场地管理－预约库存管理 -->
    <content-view>
		<div slot="header">
			<a-form :form="form" class="ticket-one-form" @submit="handleSearch(1)">
				<table>
					<tr>
						<td>
							库存名称：
						</td>
						<td>
							<a-form-item style="margin:0;">
								<a-input v-decorator="['name']"></a-input>
							</a-form-item>
						</td>
						<td>
							<div class="ml16">
								<a-button type="primary" html-type="submit">筛选</a-button>
								<a-button @click="resetForm">重置</a-button>
							</div>
						</td>
					</tr>
				</table>
			</a-form>
		</div>
        <div class="inventory-item-manage">
      		<a-alert style="margin-bottom:20px" description="删除后连同该库存项目下的场次也一并删除操作，请慎重操作！" type="warning" showIcon/>
			<a-table bordered @change="change" :columns="columns" :dataSource="storeList" :pagination="pagination" :rowKey="(record)=> record.id">
				<template slot="listNum" slot-scope="value,record,index">
					{{index+1|listNumber}}
				</template>
				<template slot="action" slot-scope="value,record,index">
					<a class="text-primary" @click="openEdit(record)">编辑</a>
					<a-divider type="vertical"></a-divider>
					<a-popconfirm title="删除后连同该库存项目下的场次也一并删除操作，确认删除？" @confirm="deleteStore(record.id)" okText="是" cancelText="否">
						<a class="text-primary">删除</a>
					</a-popconfirm>
				</template>
			</a-table>
		</div>
		<!-- 修改库存项目名称 -->
        <a-modal
			centered
            title="编辑"
			okText="修改"
            :visible="visible"
            :confirmLoading="confirmLoading"
            @ok="editStore"
            @cancel="handleCancel"
			:destroyOnClose="true"
        >
			<a-form :form="editForm" class="store-one-form">
				<a-form-item label="库存项目名称：" :label-col="{span: 6}" :wrapper-col="{span: 16}">
					<a-input placeholder="请输入" v-decorator="['name', {initialValue: currentRow.name}, {rules:[{required:true,message:'请填写！'}]}]"></a-input>
				</a-form-item>
			</a-form>
        </a-modal>
    </content-view>
</template>

<script type="text/javascript">
import moment from "moment";
import { mapGetters } from "vuex"
const columns=[{
		title: '序号',
		width:"10%",
		scopedSlots: { customRender: 'listNum' },
	},
	{
		title: '库存名称',
		dataIndex:"name"
	},
	{
		title: '操作',
		width:"25%",
		scopedSlots: { customRender: 'action' },
	}];
export default {
    name: "amendScreening",
    components: {},
    props: {},
    data() {
		/**
		 * @visible 编辑显示状态
		 * @columns 表头
		 * @shopId 店铺id
		 * @storeList 库存项目列表
		 * @pagination 表格分页参数
		 * @loading 是否在请求中
		 * @confirmLoading 弹出确认按钮加载状态
		 */
        return {
			visible:false,
			columns,
			storeList:[],
			pagination:{
				current:1,
				defaultCurrent: 1,
				defaultPageSize: 10,
				pageSize:20,
				pageSizeOptions: ['10', '20', '30', '40'],
				showQuickJumper:true,
				showSizeChanger:true,
				total:0,
			},
			deleteLoading:false,
			confirmLoading:false,
			currentRow: {},
        };
    },
	computed: {
		...mapGetters(["shopId"])
	},
	watch:{
		shopId () {
			this.getStore();
		},
	},
	filters: {
		//表格序号过滤器
		listNumber (index) {
			return index < 10 ? "00" + index : index < 100 ? "0" +index : index < 1000? "0" + index : index;
		}
	},
    methods: {
		moment,
		//打开编辑弹窗
		openEdit (record) {
			this.visible = true;
			this.currentRow = record;
		},
		//关闭编辑弹窗
		handleCancel () {
			this.visible = false;
		},
		// 表格分页按钮改变事件
		change (page, pageSize) {
			this.pagination.current = page.current;
			this.pagination.pageSize = page.pageSize;
			this.getStore();
		},	
		// 表格分页条数改变事件
		showSizeChange (current, size) {
			this.getStore();
		},
		//重置表单
		resetForm () {
			this.pagination.current = 1;
			this.pagination.pageSize = 20;
			this.form.resetFields();
			this.getStore();
		},
		//获取库存项目数据
		getStore() {
			if (!this.shopId) {
				return false;
			}
			this.form.validateFields((err,values) => {
				if (err) return;
				this.$api.totalPlatform.getStore({
					body: {
						shopId: this.$store.state.platform.shopId,
						stockCategory: 'TICKET',
						name: values.name
					}
				}).then(res => {
					this.storeList = res;
				});
			});
		},
		// 库存数据筛选按钮回调
        handleSearch () {
			this.pagination.current = 1;
			this.getStore ();
		},
		// 库存删除
		deleteStore (id) {
			if(this.deleteLoading){
				return;
			}
			this.deleteLoading=true;
			this.$api.totalPlatform.delStoreConfig({
				params: {
					id: id
				},
			}).then(res => {
				this.$message.success("删除成功！");
				this.deleteLoading = false;
				this.getStore();
			}).catch(res => {
				this.deleteLoading = false;
			})
		},
		//库存编辑
		editStore () {
			if(this.confirmLoading){
				return;
			}
			this.editForm.validateFields((err,values) => {
				if(!err){
					this.confirmLoading = true;
					this.$api.totalPlatform.editStoreConfig({
						body : {
							id : this.currentRow.id,
							name : values.name,
							shopId: this.shopId,
							stockCategory: 'TICKET'
						},
					}).then(res => {
						this.$message.success("操作成功！");
						this.visible = false;
						this.confirmLoading = false;
						this.getStore();
					}).catch(res => {
						this.visible = false;
						this.confirmLoading = false;
					})
				}
			})
			
		}
	},
	beforeCreate(){
		this.form = this.$form.createForm(this);
		this.editForm = this.$form.createForm(this);
	},
	created() {},
    mounted() {
		this.getStore();
	}
};
</script>
<style lang="scss">
	.inventory-item-manage{
		background-color: #fff;
		padding: 24px 32px;
		border-radius: 2px;
		min-height: 650px;
	}
</style>